import { render, staticRenderFns } from "./BallotEntryScoresheet.vue?vue&type=template&id=0090e632&"
import script from "./BallotEntryScoresheet.vue?vue&type=script&lang=js&"
export * from "./BallotEntryScoresheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports